import { default as indexsThdLZKTKzMeta } from "/var/www/orthofresh2/pages/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/orthofresh2/pages/index.vue").then(m => m.default || m)
  }
]